<template>
    <section id="home-slide-security" class="py-5 text-start container-fluid">

        <div class="row items-center p-lg-5">
            <div class="col-3 text-end me-n5 image hidden lg:block">
                <img src="/static/img/SECURITY.jpg" height="400" />
            </div>
            <div class="ps-lg-5 col-lg-9 explain">
                <h1 class="m-lg-5 m-3 lg:shrink-2 shrink-4">{{ gettext("Sécurité & confidentialité") }}</h1>
                <p class="lg:shrink-2 shrink-5 px-lg-5 px-3">
                    Hébergement sur des
                    <b>{{ gettext("serveurs certifiés ISO 27001") }}</b>
                    (norme de sécurité des systèmes d'information) et
                    <b>{{ gettext("PCI-DSS") }}</b> (norme de l’industrie des cartes de paiement).
                    Tous les <b>{{ gettext("échanges sont entièrement chiffrés") }}</b>
                    via le protocole SSL/TLS et une clef cryptographique de 2048 bits pour garantir leur confidentialité.
                    <b>{{ gettext("Notre politique de confidentialité") }}</b> (gestion des données) est conforme au RGPD et
                    <b>{{ gettext("toutes les données sont stockées en Europe") }}</b>.
                </p>
                <div class="m-5">
                    <button type="button" class="btn btn-lg btn-block btn-secondary shrink-3" @click="goToContact()">{{ gettext("Demander une démo") }}</button>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import slide from "@/pages/habitat/slideHabitat/slide.js";

export default {
    mixins: [slide],
}
</script>

<style scoped lang="scss">
@import "@/assets/vars.scss";
#home-slide-security {
    color: $primary;
    > div > .image {
        z-index: 1;
    }
    > div > .explain {
        background-color: #ececec;
    }
}
</style>
